module.exports = __webpack_public_path__ + "static/media/gh-map-greenspace-tc.92662c8b.png";